import LoginLogoShader from './login/LoginLogoShader';
import LoginShaderBackground from './login/LoginShaderBackground';
import { GlowGhostIcon, SecondaryActionButton } from './ui';
import './LoginPage.css';
import './SentryErrorBoundary.css';

export default function BrandedRecoveryScreen({
  message,
  actionLabel,
  onAction,
}) {
  return (
    <div className="sentry-error-boundary">
      <LoginShaderBackground />
      <div className="sentry-error-boundary__content login-page-auth-card">
        <div className="login-page-brand-zone">
          <div className="login-page-brand-mark" role="img" aria-label="Modul">
            <LoginLogoShader />
            <GlowGhostIcon className="login-page-brand-mark__icon sentry-error-boundary__icon" />
          </div>
        </div>

        <div className="sentry-error-boundary__controls login-page-auth-controls">
          <p className="sentry-error-boundary__message">{message}</p>
          <SecondaryActionButton className="login-page-auth-button" onClick={onAction}>
            {actionLabel}
          </SecondaryActionButton>
        </div>
      </div>
    </div>
  );
}
